export default __webpack_public_path__ + "media/09b7df841537322147a11eaba06a98c397a097072c2576c19bc9b3142af767c0.svg";